/**
 * @generated SignedSource<<61bd3bf73fbaa0875f3d4198cf3fdd61>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationMembershipKind = "ADMIN" | "EDITOR" | "OWNER" | "READER";
import { FragmentRefs } from "relay-runtime";
export type UserOrganizationsFragment$data = {
  readonly id: string;
  readonly organizations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: OrganizationMembershipKind;
        readonly organization: {
          readonly displayName: string;
          readonly id: string;
          readonly username: string;
          readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
        };
        readonly viewerCanDelete: boolean;
      };
    }>;
  };
  readonly " $fragmentType": "UserOrganizationsFragment";
};
export type UserOrganizationsFragment$key = {
  readonly " $data"?: UserOrganizationsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserOrganizationsFragment">;
};

import UserOrganizationsFragmentPaginationQuery_graphql from './UserOrganizationsFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "organizations"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserOrganizationsFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserOrganizationsFragment",
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": "organizations",
      "args": null,
      "concreteType": "UserOrganizationConnection",
      "kind": "LinkedField",
      "name": "__UserOrganizationsFragment_organizations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": "viewerCanDelete",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "action",
                      "value": "REMOVE_ORGANIZATION_MEMBER"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "viewerCan",
                  "storageKey": "viewerCan(action:\"REMOVE_ORGANIZATION_MEMBER\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "username",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "thumbnail",
                          "value": true
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "EntityProfilePicFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "d51c4778a29c4eeaa7b4e6e3542d59fd";

export default node;
